import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const ReceiptReportRedux = createActions(
  {
    ReceiptReportRequest: ['start_date', 'end_date'],
    ReceiptReportSuccess: ['data', 'fileName'],
    ReceiptReportError: ['error'],
    CentersReceiptReportRequest: ['start_date','end_date','centerId'],
    CentersReceiptReportSuccess: ['data', 'fileName'],
    CentersReceiptReportError: ['error'],
  },
  {
    prefix: 'RECEIPTREPORT_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = ReceiptReportRedux
export const ReceiptReportTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

/* ------------- Reducers ------------- */

const ReceiptReportRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const ReceiptReportSuccess = (state, { data, fileName }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  data: { file: data, fileName }
}, d)
const ReceiptReportError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

const CentersReceiptReportRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const CentersReceiptReportSuccess = (state, { data, fileName }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  data: { file: data, fileName }
}, d)
const CentersReceiptReportError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.ReceiptReportRequest]: ReceiptReportRequest,
    [Types.ReceiptReportSuccess]: ReceiptReportSuccess,
    [Types.ReceiptReportError]: ReceiptReportError,
    [Types.CentersReceiptReportRequest]: CentersReceiptReportRequest,
    [Types.CentersReceiptReportSuccess]: CentersReceiptReportSuccess,
    [Types.CentersReceiptReportError]: CentersReceiptReportError,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ReceiptReportRedux.js